import api from "./interceptor";
import config from "../config";
import { CryptoMethods } from "../utils/crypto-methods";
const BUFFER = 5000;
const TERMS_AND_CONDITION_STORAGE_KEY = "termsAndCondition";

export const getSsoUrl = async () => {
  try {
    const response = await api.get(config.userEndPoints.getSsoUrl);
    return response.data.data.awsSsoUrl;
  } catch (error) {
    console.error("Error fetching SSO URL:", error);
    return error;
  }
};

export const ssoLogin = async (authCode: any) => {
  try {
    const response = await api.post(config.userEndPoints.ssoLogin, {
      type: "aws",
      authCode,
    });
    const user = response?.data?.data?.user;
    user.accessToken = await CryptoMethods.decryptData(user.accessToken);
    user.refreshToken = await CryptoMethods.decryptData(user.refreshToken);
    return response.data.data.user;
  } catch (error) {
    console.error("Error validating SSO login:", error);
    return error;
  }
};

export const ssoLogout = async () => {
  try {
    // TO DO: Backend API will be implemented in the future
    await api.post(config.userEndPoints.ssoLogout, {});
    localStorage.clear();
    sessionStorage.clear();
    const env = config.env;
    const cognitoUrl = config[env + 'CognitoUrl'];
    const clientId = config[env + 'ClientId'];
    const logoutUri = encodeURIComponent(window.location.origin);
    
    const signOutUrl = `${cognitoUrl}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
    window.open(signOutUrl, "_self");
  } catch (error) {
    return error;
  }
};

export const setTermsAndConditionStatus = (status: boolean) => {
  localStorage.setItem(TERMS_AND_CONDITION_STORAGE_KEY, String(status));
};

export const getTermsAndConditionStatus = (): boolean | null => {
  const storedValue = localStorage.getItem(TERMS_AND_CONDITION_STORAGE_KEY);

  if (storedValue === "true") {
    return true;
  }

  if (storedValue === "false") {
    return false;
  }

  return null;
};

export function getTokenPlayload() {
  const token = localStorage.getItem("accessToken") ?? '';
  if (token == undefined || token == "undefined" || !token) {
    return null;
  }
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

export function isValidToken(): boolean {
  const userData = getTokenPlayload();
  return Boolean(
    userData && userData.exp * 1000 > new Date().getTime() + BUFFER
  );
}

export const getEncryptionConfig = async () => {
  const response = await api.get(config.userEndPoints.encryptionConfig, {
    headers: { 'x-api-key': config.xApiKey }
  });
  return response?.data?.data?.encryptionConfig;
}

export const updateTermsAndConditionAcceptance = async (
  termsAndConditionId: string | number,
) => {
  try {
    const response = await api.patch(
      `${config.userEndPoints.userMeta}`,
      {
        termsAndCondition: {
          update: true,
          isAccepted: true,
          termsAndConditionId: Number(termsAndConditionId),
        },
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
};
